var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bankingProvider === 'plaid')?_c('VerifyBankPlaid',{attrs:{"docs-stand-alone":_vm.docsStandAlone,"event-prefix":_vm.eventPrefix},on:{"switch-to-flinks":_vm.handleSwitchToFlinks}}):_c('VerifyBankFlinks',{attrs:{"docs-stand-alone":_vm.docsStandAlone,"event-prefix":_vm.eventPrefix,"instituition-id":_vm.instituitionId}})
}
var staticRenderFns = []

export { render, staticRenderFns }